import React, { useContext, createContext, useState } from "react";
import { useRecoilState } from "recoil";
import Header from "./header";
import { useLocale } from "react-aria";

import Footer from "./footer";
import { langState, firstLoadState } from "./recoilAtom";
import CookieBanner from "./cookies/cookies";
import PermissionBanner from "./cookies/permission-for-hcp";

interface layoutProps {
  children?: React.ReactNode;
}

const Layout: React.FC<layoutProps> = ({ children }) => {
  const [lang, setLang] = useRecoilState(langState);
  const { locale } = useLocale();
  const [firstLoad, setFirstLoad] = useRecoilState(firstLoadState);

  React.useEffect(() => {
    firstLoad && setLang(locale);
    setFirstLoad(false);
  }, []);

  return (
    <main
      lang={lang}
      className="w-screen flex flex-col justify-center items-center"
    >
      <Header className="w-screen flex flex-col justify-center items-center" />
      {children}
      <CookieBanner />
      <PermissionBanner />
      <Footer className="flex flex-col justify-center items-center p-0 mt-0 gap-0 max-w-full w-full text-base" />
    </main>
  );
};

export default Layout;

interface contentWrapperProps {
  className?: string;
  children?: React.ReactNode;
}

export const ContentWrapper: React.FC<contentWrapperProps> = ({
  className,
  children,
}) => (
  <div
    className={`flex flex-col justify-center items-center px-6 gap-4 max-w-full lg:max-w-[1400px] w-full ${className}`}
  >
    {children}
  </div>
);
